import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdateContact } from 'api/contacts/use-update-contact';
import type { ContactRes } from 'api/swagger';
import { FormDrawer } from 'components/common/form-drawer';
import type { IContactFormFields } from 'components/contacts/contact-form';
import { ContactForm } from 'components/contacts/contact-form';

interface IEditContactProps {
  contact: ContactRes;
  isOpen: boolean;
  onClose: () => void;
}

export const EditContact: React.FC<IEditContactProps> = (props) => {
  const { contact, isOpen, onClose } = props;
  const { t } = useTranslation();
  const { mutateAsync: updateContact, isLoading } = useUpdateContact(contact.id);

  const handleFinish = async (value: IContactFormFields) => {
    await updateContact(value);
  };

  return (
    <FormDrawer
      formComponent={ContactForm}
      formProps={{ initialValues: contact }}
      title={t('contact:edit_contact')}
      isLoading={isLoading}
      isOpen={isOpen}
      onFinish={handleFinish}
      onClose={onClose}
    />
  );
};
